import { createSelector } from 'reselect'

import identitySelector from '../identity_selector'
import questionStatus from 'helpers/enums/creationTool/questionStatus'

const interactiveVideoCreationSelector = state => state.interactiveVideoCreation
const oeqActivitySelector = state => state.creationTool.oeq

const oeqSaveSelector = createSelector(
	[
		interactiveVideoCreationSelector,
		oeqActivitySelector,
		identitySelector,
	],
	(
		interactiveVideoCreation,
		oeq,
		identity
	) => {
		const questionSavingDone = oeq.question.status !== questionStatus.SAVING

		return {
			mediaUid: identity.uid,
			jwt: identity.jwt,
			activityUid: oeq.activityUid,
			breakpointUid: interactiveVideoCreation.currentActivity.breakpointUid,
			breakpointActivityUid: interactiveVideoCreation.currentActivity.breakpointActivityUid,
			isEdition: interactiveVideoCreation.currentActivity.isEdition,
			questionSavingDone,
		}
	}
)

export default oeqSaveSelector
